import { forwardRef, type InputHTMLAttributes } from "react";

/** Props of `HiddenField`: a form value with no look, so no `type`, `className` or `style`. */
export type HiddenFieldProps = Omit<InputHTMLAttributes<HTMLInputElement>, "type" | "className" | "style">;

/** A `<input type="hidden">` that forwards its ref (react-hook-form `register`) for values picked by another control. */
export const HiddenField = forwardRef<HTMLInputElement, HiddenFieldProps>(function HiddenField(props, ref) {
  return <input {...props} ref={ref} type="hidden" />;
});
